var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "flex flex-col gap-6" },
    [
      _c(
        "jade-box",
        {
          attrs: { title: _vm.$t("terminal") },
          scopedSlots: _vm._u([
            {
              key: "action",
              fn: function () {
                return [
                  _vm.canDoActionsTerminal
                    ? _c(
                        "jade-dropdown",
                        {
                          attrs: {
                            open: _vm.isOpen,
                            "data-testid": "actionButton",
                          },
                          on: {
                            toggleOpen: function ($event) {
                              _vm.isOpen = !_vm.isOpen
                            },
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "trigger",
                                fn: function () {
                                  return [
                                    _c(
                                      "jade-action-button",
                                      {
                                        attrs: {
                                          active: "",
                                          dropdownIndicator: "",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " + _vm._s(_vm.$t("actions")) + " "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            1901414029
                          ),
                        },
                        [
                          _c("jade-list-item", {
                            attrs: {
                              label: _vm.$t("request-paper-roll"),
                              as: "button",
                            },
                            on: {
                              onClick: function ($event) {
                                return _vm.$router.push({
                                  name: _vm.terminalRollRequestRouteName,
                                })
                              },
                            },
                          }),
                          _c("jade-list-item", {
                            attrs: {
                              label: _vm.$t("terminal-replacement"),
                              as: "button",
                            },
                            on: {
                              onClick: function ($event) {
                                return _vm.$router.push({
                                  name: "terminalSwap",
                                  params: {
                                    serialNumber: _vm.terminal.serial_number,
                                  },
                                })
                              },
                            },
                          }),
                          _c("jade-list-item", {
                            attrs: {
                              label: _vm.$t("terminal-uninstallation"),
                              as: "button",
                            },
                            on: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "page-down",
                                    undefined,
                                    $event.key,
                                    undefined
                                  )
                                )
                                  return null
                                return _vm.terminalUninstallRoute()
                              },
                              onClick: function ($event) {
                                return _vm.terminalUninstallRoute()
                              },
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm.loadingListTerminals
            ? _c(
                "div",
                {
                  staticClass: "eu-pa_6 eu-align_center",
                  attrs: { "data-testid": "show-loading" },
                },
                [_c("emd-loader", { attrs: { type: "_invert" } })],
                1
              )
            : _c(
                "div",
                { staticClass: "py-2" },
                [
                  _c("Table", {
                    attrs: { fields: _vm.fields, items: [_vm.terminal] },
                  }),
                ],
                1
              ),
        ]
      ),
      _c(
        "jade-box",
        { attrs: { title: _vm.$t("title"), hasPadding: "" } },
        [
          _vm.loadingListTerminals
            ? _c(
                "div",
                {
                  staticClass: "eu-pa_6 eu-align_center",
                  attrs: { "data-testid": "show-loading" },
                },
                [_c("emd-loader", { attrs: { type: "_invert" } })],
                1
              )
            : _c("form-shell", {
                attrs: {
                  formsOnShell: _vm.formsOnShell,
                  onlyFields: "",
                  removePadding: "",
                },
              }),
        ],
        1
      ),
      _c("history-details", {
        attrs: {
          historyFields: _vm.historyFields,
          loading: _vm.loadingListTerminals,
          title: "terminal-history",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }